// モフトレチェック.
import { MoffCheck } from '../api/MoffCheck';
import { AppUserAPI } from '../api/AppUser';
import * as Moff from '../constants/MoffAPI';
import * as MoffCheckConst from '../constants/MoffCheck';
import * as AppUser from '../constants/AppUser';
import { MoffAPI } from '../api/MoffAPI';
import { getCurrentTime, convertInterestCheckUpdateDate } from '../utils/dateUtil';

/**
 * TUG測定データ
 * getMoffCheckDataから呼ばれたgetAppUserから呼ばれる.
 * 特定期間内の件数,内訳を取得.
 *
 * @param {any} resultOfUser
 * @param {*} resultOfTUG TUGの結果を渡す.
 * @param {MoffCheck} moffCheck
 * @param {string} uniqueId
 * @param {string} startDate
 * @param {string} endDate
 * @returns
 */
const getBalanceRecords = (
  resultOfUser: any, resultOfTUG: any, moffCheck: MoffCheck, uniqueId: string, startDate: string, endDate: string) => {
  return moffCheck.getBalanceRecords(
    uniqueId, startDate, endDate,
    () => {
      return {
        type: MoffCheckConst.START_LOAD,
        result: null,
      };
    },
    (statusOfBalance: any, resultOfBalance: any) => {
      switch (statusOfBalance) {
        case MoffCheckConst.START_LOAD:
          return {
            type: MoffCheckConst.START_LOAD,
            result: null,
          };
        case MoffCheckConst.ERROR:
          return {
            type: MoffCheckConst.ERROR,
            result: resultOfBalance,
          };
        case MoffCheckConst.SUCCESS:
          return {
            type: MoffCheckConst.SUCCESS,
            result: {
              user: resultOfUser,
              tug: resultOfTUG,
              balance: resultOfBalance,
            }
          };
        default:
          return {
            type: MoffCheckConst.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * アプリユーザーAPI
 * 
 * @param {any} resultOfUser
 * @param {string} userId
 * @param {string} startDate
 * @param {string} endDate
 * @returns
 */
const getAppUser = (resultOfUser: any, userId: string, startDate: string, endDate: string) => {
  const appUserAPI = AppUserAPI.instance;
  if (appUserAPI === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  const moffCheck = MoffCheck.instance;
  if (moffCheck === null) {
    return {
      type: MoffCheckConst.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // アプリユーザーAPI.
  return appUserAPI.getAppUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case AppUser.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case AppUser.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case AppUser.SUCCESS:
          const uniqueId = (resultOfGetUser.data as AppUser.ResponseData).unique_id;
          // TUG測定データ.
          return moffCheck.getTUGRecords(
            uniqueId, startDate, endDate,
            () => {
              return {
                type: MoffCheckConst.START_LOAD,
                result: null,
              };
            },
            (statusOfTUG: any, resultOfTUG: any) => {
              switch (statusOfTUG) {
                case MoffCheckConst.START_LOAD:
                  return {
                    type: MoffCheckConst.START_LOAD,
                    result: null,
                  };
                case MoffCheckConst.ERROR:
                  return {
                    type: MoffCheckConst.ERROR,
                    result: resultOfTUG,
                  };
                case MoffCheckConst.SUCCESS:
                  // バランス測定データ（開眼片足立立位）
                  return getBalanceRecords(resultOfUser, resultOfTUG, moffCheck, uniqueId, startDate, endDate);
                default:
                  return {
                    type: MoffCheckConst.ERROR,
                    result: '不明なエラーが発生しました.',
                  };
              }
            }
          );
        default:
          return {
            type: AppUser.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * モフトレチェック画面.
 *
 * @param {string} userId
 * @param {string} startDate
 * @param {string} endDate
 * @returns
 */
export const getMoffCheckData = (userId: string, startDate: string, endDate: string) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }
  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    (statusOfUser: any, resultOfUser: any) => {
      // 定数はMoff
      switch (statusOfUser) {
        case Moff.LOADING:
          return {
            type: MoffCheckConst.START_LOAD,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: MoffCheckConst.ERROR,
            result: resultOfUser,
          };
        case Moff.SUCCESS:
          // あるかチェック.
          return getAppUser(resultOfUser, userId, startDate, endDate);
        default:
          return {
            type: MoffCheckConst.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }          
  );
};

/**
 * TUG/片足立ちの最終登録日を取得する.
 *
 * @param {string} userId
 * @param {string} uniqueId
 * @param {HTMLElement[]} elements
 * @returns {*}
 */
const getTUGBalanceRecordsLatest = (userId: string, uniqueId: string, elements: HTMLElement[]): any => {
  // API
  const moffCheck = MoffCheck.instance;
  if (moffCheck === null) {
    return {
      type: MoffCheckConst.FINISH,
      result: '不明なエラーが発生しました.',
    };
  }

  // TUGの最終登録日を取得.
  return moffCheck.getTUGRecordsLatest(
    uniqueId,
    () => {
      return {
        // ここはSTART_LOADにしてはならない.
        type: MoffCheckConst.LOADING,
        result: null,
      };
    },
    (statusOfGetTUGRecordsLatest: any, resultOfGetTUGRecordsLatest: any) => {
      switch (statusOfGetTUGRecordsLatest) {
        case MoffCheckConst.START_LOAD:
          return {
            type: MoffCheckConst.START_LOAD,
            result: null,
          };
        case MoffCheckConst.ERROR:
        case MoffCheckConst.SUCCESS:
          // 最後の日付.
          let tugUpdateDate: string = '';

          // エラーではないときだけ.
          if (!resultOfGetTUGRecordsLatest.toString().includes('Error:')) {
            tugUpdateDate = resultOfGetTUGRecordsLatest.created_at;
          }

          // 開眼片足立ちの最終登録日を取得.
          return moffCheck.getBalanceRecordsLatest(
            uniqueId,
            () => {
              return {
                type: MoffCheckConst.LOADING,
                result: null,
              };
            },
            // ステータス,結果（値 or エラーメッセージ）
            (statusOfGeBalanceRecordsLatest: any, resultOfGetBalanceRecordsLatest: any) => {
              switch (statusOfGeBalanceRecordsLatest) {
                case MoffCheckConst.LOADING:
                  return {
                    type: MoffCheckConst.LOADING,
                    result: null,
                  };
                case MoffCheckConst.ERROR:
                case MoffCheckConst.SUCCESS:
                  // 最後の日付.
                  let updateDate: string = '';

                  // エラーではないときだけ.
                  if (!resultOfGetBalanceRecordsLatest.toString().includes('Error:')) {
                    updateDate = resultOfGetBalanceRecordsLatest.created_at;
                  }

                  // 片足立ちの最後の日付で大きいほう.
                  if (tugUpdateDate > updateDate) {
                    updateDate = tugUpdateDate;
                  }

                  // 日付がなければすぐに返却.
                  if (updateDate === '') {
                    return {
                      type: MoffCheckConst.FINISH,
                      result: resultOfGetBalanceRecordsLatest,
                    };
                  }

                  // 今日 yyyy-mm-dd
                  const today: string = getCurrentTime().day;

                  // 変換: "2018-09-04 16:26:04" => "2018/09/04"
                  updateDate = convertInterestCheckUpdateDate(updateDate);

                  // 年月日の隙間の記号は"/"ではなく"-".
                  const isToday = (today === updateDate.replace(/\//g, '-'));
                  if (isToday) {
                    updateDate = '本日';
                    // 色を変化させる.
                    elements[userId].className = 'kirokuToday';
                  }

                  elements[userId].innerText = updateDate;

                  return {
                    type: MoffCheckConst.FINISH,
                    result: resultOfGetBalanceRecordsLatest,
                  };
                default:
                  return {
                    type: MoffCheckConst.FINISH,
                    result: '不明なエラーが発生しました.',
                  };
              }
            }
          );
        default:
          return {
            type: MoffCheckConst.FINISH,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * 各モフトレチェックの最終登録日を取得する.
 * Componentから呼ばれる.
 *
 * @param {string} userId
 * @returns
 */
export const getMoffCheckLastDate = (userId: string, elements: HTMLElement[]): any => {
  // API
  const appUser = AppUserAPI.instance;
  if (appUser === null) {
    return {
      type: MoffCheckConst.FINISH,
      result: '不明なエラーが発生しました.',
    };
  }

  // まずそのユーザのuniqueIdを取得する.
  return appUser.getAppUser(
    userId,
    () => {
      return {
        // 0リセットになる.
        type: MoffCheckConst.START_LOAD,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case AppUser.LOADING:
          return {
            type: MoffCheckConst.LOADING,
            result: null,
          };
        case AppUser.ERROR:
          return {
            type: MoffCheckConst.FINISH,
            result: resultOfGetUser,
          };
        case AppUser.SUCCESS:
          const uniqueId = resultOfGetUser.data.unique_id;
          return getTUGBalanceRecordsLatest(userId, uniqueId, elements);
        default:
          return {
            type: MoffCheckConst.FINISH,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};


// WEBPACK FOOTER //
// ./src/actions/MoffCheck.tsx